
import { defineComponent } from 'vue'
import { ReportFilter, ReportFilterType } from '@/model/models'
import ReportCheckBoxFilter from '@/components/ReportCheckBoxFilter.vue'
import ReportSelectFilter from '@/components/ReportSelectFilter.vue'
import ReportTimeRangeFilter from '@/components/ReportTimeRangeFilter.vue'
import ReportSmallTimeRangeFilter from '@/components/ReportSmallTimeRangeFilter.vue'

export default defineComponent( {
  name: 'ReportFilterView',
  components: {
    ReportCheckBoxFilter,
    ReportSelectFilter,
    ReportTimeRangeFilter,
    ReportSmallTimeRangeFilter
  },
  props: {
    filter: ReportFilter,
    preselect: null
  },
  emits: [
    'filter-changed'
  ],
  methods: {
    onFilterChanged(data: any) {
      this.$emit('filter-changed', data)
    }
  },
  computed: {
    isCheckboxFilter() {
      return this.filter?.type === ReportFilterType.CheckBox
    },
    isSelectFilter() {
      return this.filter?.type === ReportFilterType.SingleSelect
          || this.filter?.type === ReportFilterType.MultiSelect
          || this.filter?.type === ReportFilterType.AutoComplete
    },
    isTimeRangeFilter() {
      return this.filter?.type === ReportFilterType.TimeRange
    },
    isSmallTimeRangeFilter() {
      return this.filter?.type === ReportFilterType.SmallTimeRange
    }
  }
})
